import { Component, OnInit, OnDestroy } from '@angular/core';
import { MonitorStatus } from '../model/monitoring.model';
import { MonitoringService } from '../service/monitoring.service';
import { FormControl } from '@angular/forms';
import { SearchService } from '../service/search.service';
import { findIndex } from 'rxjs/operators';
import { SubscriptionService } from '../service/subscription.service';
import { Subscription } from 'rxjs';
import 'parse';
import { environment } from '../../environments/environment';
import { SelectPossibleOption } from '../model/search';
import { Device } from '../model/device.model';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.less']
})

export class MonitoringComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  monitor: Array<MonitorStatus>;
  page: string = 'global';
  selectStyleGuide = {
    caretClass: 'caret',
    selectBoxClass: 'dropdown-wrapper dropdown-current-bold ',
    selectMenuClass: 'dropdown',
    optionsClass: 'option'
  };
  possibleValuesDevice: SelectPossibleOption[] = [];
  possibleValuesCompany: SelectPossibleOption[] = [];
  possibleValuesLocation: SelectPossibleOption[] = [];
  newValueSelectDevice: string;
  newValueSelectCompany: string;
  newValueSelectLocation: string;

  deviceStore: Array<Device>;
  filterDeviceStore: Array<Device>;
  filterDeviceStoreMonitor: Array<MonitorStatus>;
  logsStore: Array<any>;
  filterLogsStore: Array<any> = [];

  constructor(
    private readonly _monitoringService: MonitoringService,
    private readonly _searchService: SearchService,
    private readonly _subscriptionService: SubscriptionService
  ) {
    this.resetSelect();
    this._monitoringService.getMonitorStatus().then(result => {
      this.filterDeviceStoreMonitor = result
    })
    this._searchService.getDevicesTyped().then(alldev => {
      this.deviceStore = alldev;
      alldev.forEach(device => {
        this.filterDeviceStore = alldev
        this.possibleValuesDevice.push({ key: device.id, value: device.serialNumber });
        if (device.companyIdentifier && this.possibleValuesCompany.findIndex(i => (i.key === device.companyIdentifier)) === -1)
          this.possibleValuesCompany.push({ key: device.companyIdentifier, value: device.companyIdentifier });
        if (this.possibleValuesLocation.findIndex(i => (i.key === device.address)) === -1)
          this.possibleValuesLocation.push({ key: device.address, value: device.address });
      });
      this._monitoringService.getEventsLogs().then(data => {
        data.forEach(log => {
          this.deviceStore.forEach(device => {
            if (!environment.isLocal)
              if (log.deviceId === device.webObjectId)
                log.deviceName = device.serialNumber
              else
                if (log.deviceId === device.id)
                  log.deviceName = device.serialNumber
          })
        });
        this.logsStore = data;
        this.logsStore.forEach(log => {
          this.filterLogsStore.push(log)
        });
      });
    })
  }

  eventsLog() {
    const query = new parse.Query('EventsLog');
    this._subscriptionService.sub(query, 'eventsLog');
    this._subscriptionService.listen('eventsLog', 'create', data => {
      console.log('new event log', data);
    });
  }

  frontLog() {
    const query = new parse.Query('Log');
    this._subscriptionService.sub(query, 'log');
    this._subscriptionService.listen('log', 'create', data => {
      console.log('new front log', data);
    });
  }

  monitorStatus() {
    console.log("monitorStatus");
    const query = new parse.Query('MonitorStatus');
    this._subscriptionService.sub(query, 'MonitorStatus');
    this._subscriptionService.listen('MonitorStatus', 'create', data => {
      console.log('new MonitorStatus', data);
    });
    this._subscriptionService.listen('MonitorStatus', 'update', data => {
      console.log('update MonitorStatus', data);
      this.filterDeviceStoreMonitor.forEach(monitor => {
        if (monitor.id === data.id) {
          let dataM = new MonitorStatus(data)
          let tmp = this._monitoringService.getMonitorCritical(dataM)
          if (tmp.length > 0) {
            monitor.critical = tmp
            this.placeDeviceToTop(monitor.devicePtr.id)
          } else monitor.critical = undefined
        }
      })
    });
  }

  placeDeviceToTop(deviceId: string) {
    let index = this.filterDeviceStore.findIndex(device => { return device.id === deviceId })
    this.filterDeviceStore.unshift(this.filterDeviceStore[index])
    this.filterDeviceStore.splice(index + 1, 1)
  }

  ngOnInit() {
    this.eventsLog()
    this.monitorStatus()
    this.frontLog()
  }

  ngOnDestroy(): void {
    try {
      console.log('destroy sub ')
      this._subscriptionService.unsub('eventsLog');
      this._subscriptionService.unsub('log');
      this._subscriptionService.unsub('monitorStatus');
    } catch (e) { console.log(e); }
  }


  resetSelect() {
    this.filterDeviceStore = [];
    this.filterDeviceStoreMonitor = [];
    this.filterLogsStore = [];
    this.possibleValuesDevice = [];
    this.possibleValuesCompany = [];
    this.possibleValuesLocation = [];
  }


  changePage(page: string) {
    this.page = page;
  }

  handlerChangeLocation(locationSelected) {
    console.log('change location', locationSelected);
    this.resetSelect();
    this.newValueSelectDevice = null
    this.newValueSelectCompany = null
    this.deviceStore.forEach(device => {
      if (this.possibleValuesLocation.findIndex(i => (i.key === device.address)) === -1)
        this.possibleValuesLocation.push({ key: device.address, value: device.address });
      if (locationSelected === undefined || device.address === locationSelected.key) {
        this.makestore(device);
        this.possibleValuesDevice.push({ key: device.id, value: device.serialNumber });
        if (device.companyIdentifier && this.possibleValuesCompany.findIndex(i => (i.key === device.companyIdentifier)) === -1)
          this.possibleValuesCompany.push({ key: device.companyIdentifier, value: device.companyIdentifier });
      }
    });
  }

  handlerChangeDevice(deviceSelected) {
    console.log('change device', deviceSelected);
    this.resetSelect();
    if (deviceSelected === undefined) {
      this.newValueSelectCompany = null
      this.newValueSelectLocation = null
    }
    this.deviceStore.forEach(device => {
      console.log(device);
      this.possibleValuesDevice.push({ key: device.id, value: device.serialNumber });
      if (deviceSelected === undefined || device.id === deviceSelected.key) {
        this.makestore(device);
        if (device.companyIdentifier && this.possibleValuesCompany.findIndex(i => (i.key === device.companyIdentifier)) === -1)
          this.possibleValuesCompany.push({ key: device.companyIdentifier, value: device.companyIdentifier });
        if (this.possibleValuesLocation.findIndex(i => (i.key === device.address)) === -1)
          this.possibleValuesLocation.push({ key: device.address, value: device.address });
      }
    });
  }

  handlerChangeCompany(companySelected) {
    console.log('change company', companySelected);
    this.resetSelect();
    this.newValueSelectDevice = null
    this.newValueSelectLocation = null
    this.deviceStore.forEach(device => {
      if (device.companyIdentifier && this.possibleValuesCompany.findIndex(i => (i.key === device.companyIdentifier)) === -1)
        this.possibleValuesCompany.push({ key: device.companyIdentifier, value: device.companyIdentifier });
      if (companySelected === undefined || device.companyIdentifier === companySelected.key) {
        this.makestore(device);
        this.possibleValuesDevice.push({ key: device.id, value: device.serialNumber });
        if (this.possibleValuesLocation.findIndex(i => (i.key === device.address)) === -1)
          this.possibleValuesLocation.push({ key: device.address, value: device.address });
      }
    });
  }


  makestore(device: Device) {
    this.filterDeviceStore.push(device)
    let index = this._monitoringService.monitorStatusList.findIndex(m => { return m.devicePtr.id === device.id })
    if (index !== -1) this.filterDeviceStoreMonitor.push(this._monitoringService.monitorStatusList[index])
    this.logsStore.forEach(log => {
      if (log.deviceId === device.webObjectId) {
        this.filterLogsStore.push(log)
      }
    });
  }

  getMonitor(deviceId: string): MonitorStatus {
    let monitor = this.filterDeviceStoreMonitor.filter(m => { return (m.devicePtr && m.devicePtr.id === deviceId) })
    if (monitor.length > 0) return monitor[0]
    else return undefined
  }

  getBrutData(monitor: MonitorStatus): { key: string, value: string }[] {
    let data: { key: string, value: string }[] = []
    for (let [key, value] of Object.entries(monitor.getParseInstance().attributes)) {
      data.push({ key, value: value.toString() })
    }
    return data
  }

}


// WEBPACK FOOTER //
// ./src/app/monitoring/monitoring.component.ts